import { ReactElement, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  DropdownWrapper,
  EditableDropdown,
  PageWrapper
} from '../../../../../components'
import { DropdownListProps } from '../../../../../components/EditableDropdown/typings'
import {
  getBranchDropdown,
  getCoursesDropdown,
  getInstituteDropdown
} from '../../../../../helpers'
import strings from '../../../../../locale/en'
import { resetBatches } from '../../../../../redux/batch/action'
import { getBranchesForCourse } from '../../../../../redux/branch/api'
import { getBatches, getBranches } from '../../../../../redux/coachingCenter/actions'
import { RootState } from '../../../../../redux/store'
import { updateStudentInformation } from '../../../../../redux/userDetail/actions'
import { getBatchDropdown } from '../../helpers'
import {
  academicYearList,
  admissionTypeList,
  primaryLanguageList,
  secondaryLanguageList
} from './const'
import { FlexWrapper, InfoWrapper } from './subcomponents'

const CourseDetails = (): ReactElement => {
  const {
    institutes,
    branches,
    batches,
  } = useSelector(
    (state: RootState) => ({
      institutes: state.coachingCenter.institutes,
      branches: state.coachingCenter.branches,
      batches: state.coachingCenter.batches,
      studentInformation: state.userDetail.studentInformation,
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const instituteList = institutes ? getInstituteDropdown(institutes) : []
  const branchList = branches ? getBranchDropdown(branches) : []
  const batchList = batches ? getBatchDropdown(batches) : []
  const courses = batches.map((batch) => batch?.course).flat()
  const courseList = courses ? getCoursesDropdown(courses) : []

  const initialValues = {
    id: '',
    courseId: ''
  }

  const [values, setValues] = useState(initialValues)

  const {
    studentDetails: {
      admisionTypeLabel,
      admissionTypePlaceholder,
      primaryLanguage,
      secondaryLanguage,
      languagePlaceholder,
      instituteName,
      selectInstituteName,
      branchName,
      selectBranch,
      batch,
      selectBatch,
      course,
      selectCourse,
      acedemicTypeLabel,
      acedemicTypePlaceholder
    }
  } = strings

  return (
    <PageWrapper>
      <InfoWrapper>
        <FlexWrapper width="100%">
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={academicYearList}
              title={acedemicTypeLabel}
              placeholder={acedemicTypePlaceholder}
              handleSelect={(item: DropdownListProps) => {
                dispatch(updateStudentInformation({ academicYear: item.name }))
              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={admissionTypeList}
              title={admisionTypeLabel}
              placeholder={admissionTypePlaceholder}
              handleSelect={(item: DropdownListProps) => {
                dispatch(updateStudentInformation({ admissionType: item.name }))
              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              title={instituteName}
              isRequired
              dropdownList={instituteList}
              placeholder={selectInstituteName}
              handleSelect={({ id }) => {
                dispatch(updateStudentInformation({ coachingCenterId: id }))
                dispatch(getBranches({
                  coachingCentreId: id,
                }))
                setValues({ ...values, id: id })
              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              title={branchName}
              isRequired
              dropdownList={branchList}
              placeholder={selectBranch}
              isMultiChoice
              handleMultiSelect={(items) => {
                const ids = items.map((item: DropdownListProps) => item.id)
                dispatch(updateStudentInformation({ branchIds: ids }))
                dispatch(resetBatches())
                dispatch(getBatches({
                  branchId: ids,
                  coachingCentreId: values?.id
                }))
              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={batchList}
              title={batch}
              placeholder={selectBatch}
              isRequired
              isMultiChoice
              handleMultiSelect={(items) => {
                const ids = items.map((item: DropdownListProps) => item?.id)
                dispatch(updateStudentInformation({ batchIds: ids }))

              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={courseList}
              title={course}
              placeholder={selectCourse}
              isRequired
              handleSelect={({ id }) => {
                dispatch(updateStudentInformation({ courseId: id }))
                dispatch(getBranchesForCourse({
                  coachingCentreId: values?.id,
                  courseId: id
                })) 
              }}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={primaryLanguageList}
              title={primaryLanguage}
              placeholder={languagePlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ lang1: item.name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={secondaryLanguageList}
              title={secondaryLanguage}
              placeholder={languagePlaceholder}
              handleSelect={(item) =>
                dispatch(updateStudentInformation({ lang2: item.name }))
              }
            />
          </DropdownWrapper>
        </FlexWrapper>
      </InfoWrapper>
    </PageWrapper >
  )
}

export default CourseDetails
